module.exports = __webpack_public_path__ + "static/media/file.0c79dd33.png";